import React, { useState } from 'react';
import { useLanguage } from '../../../shared/contexts/LanguageContext';
import { useAuthContext } from '../../../features/auth/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useDesign } from '../../../v2/design/DesignContext';

const MobileMenu: React.FC = () => {
  const { language, setLanguage, t, isRTL } = useLanguage();
  const { isAuthenticated, logout } = useAuthContext();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { canSwitch, setDesign } = useDesign();

  const handleLogout = async () => {
    setLoading(true);
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      // ignore
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  const toggleMenu = () => setOpen(!open);

  // Only show when on small screens
  return (
    <div className="sm:hidden">
      {/* Menu trigger */}
      <button
        aria-label="menu"
        onClick={toggleMenu}
        className={`fixed top-4 ${isRTL ? 'right-4' : 'left-4'} z-50 p-2 rounded-full bg-white shadow-md border border-gray-200 focus:outline-none`}
      >
        {/* Three-dots icon that rotates */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          viewBox="0 0 24 24"
          className={`transition-transform duration-200 ${open ? 'rotate-90' : ''}`}
        >
          <circle cx="12" cy="5" r="2" />
          <circle cx="12" cy="12" r="2" />
          <circle cx="12" cy="19" r="2" />
        </svg>
      </button>

      {/* Dropdown with animation */}
      <div
        className={`fixed top-14 ${isRTL ? 'right-4' : 'left-4'} w-44 bg-white border border-gray-200 rounded-lg shadow-lg z-50 transform transition-all duration-200 ease-out ${open ? 'opacity-100 scale-100 pointer-events-auto' : 'opacity-0 scale-95 pointer-events-none'}`}
      >
        <div className="flex flex-col divide-y divide-gray-200">
          {/* Language Switcher */}
          <div className="flex items-center gap-2 px-4 py-2">
            <button
              onClick={() => {
                setLanguage('en');
              }}
              className={`flex-1 px-2 py-1 rounded-md text-center text-sm font-medium transition-colors ${language === 'en' ? 'bg-[#2e5d7d] text-white' : 'text-gray-700 hover:bg-gray-50'}`}
            >
              EN
            </button>
            <button
              onClick={() => {
                setLanguage('ar');
              }}
              className={`flex-1 px-2 py-1 rounded-md text-center text-sm font-medium transition-colors ${language === 'ar' ? 'bg-[#2e5d7d] text-white' : 'text-gray-700 hover:bg-gray-50'}`}
            >
              ع
            </button>
          </div>
          {/* Switch to the new design («التصميم الجديد») */}
          {canSwitch && (
            <button
              onClick={() => {
                setOpen(false);
                setDesign('v2');
              }}
              className="text-start px-4 py-2 text-sm font-medium text-[#2e5d7d] hover:bg-gray-50 transition-colors"
            >
              {t('switch_to_new_design')}
            </button>
          )}
          {/* Logout (only if authenticated) */}
          {isAuthenticated && (
            <button
              disabled={loading}
              onClick={handleLogout}
              className={`text-left px-4 py-2 text-sm font-medium transition-colors ${loading ? 'text-gray-400' : 'text-red-600 hover:bg-gray-50'}`}
            >
              {loading ? '...' : t('logout')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileMenu; 